var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"box-sizing":"border-box","padding":"20px 0"}},[_c('div',{staticClass:"rucontent flx alc jsc"},[_vm._v(" 登录中，请稍后... ")])])
}]

export { render, staticRenderFns }